var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('HolderForm',{attrs:{"holder":_vm.cart.holder,"$v":_vm.$v.cart.holder}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-warning"},[_c('p',[_vm._v("Ao finalizar a sua compra, você terá um Qrcode para pagamento válido por 1 hora.")])])
}]

export { render, staticRenderFns }